export default __webpack_public_path__ + "static/media/screen6.a1f9dd5b.png";